// Fases del ciclo de vida de un TicketSoporte — mismos valores que
// erp_backend/Constants/Soporte/fases.constants.js.
export const FASES_LABEL = {
  en_revision: "En revisión",
  no_enviado: "Revisado por tu empresa",
  pre_reporte: "Pre-reporte",
  rechazado: "Cerrado",
  por_hacer: "Por hacer",
  en_curso: "En curso",
  resuelto: "Resuelto",
  subido: "Subido",
};

export const FASES_COLOR_HEX = {
  en_revision: "#13a8a8",
  no_enviado: "#597ef7",
  pre_reporte: "#1890ff",
  rechazado: "#8c8c8c",
  por_hacer: "#e16b1d", // naranjaOscuro
  en_curso: "#f5d107", // mostaza
  resuelto: "#24ad44", // verdeNatural
  subido: "#5e4276", // lila
};

export const FASES_COLOR_SUAVE = {
  en_revision: { bg: "#e6fffb", border: "#87e8de", text: "#08979c" },
  no_enviado: { bg: "#f0f5ff", border: "#adc6ff", text: "#2f54eb" },
  pre_reporte: { bg: "#e6f7ff", border: "#91d5ff", text: "#096dd9" },
  rechazado: { bg: "#f5f5f5", border: "#d9d9d9", text: "#595959" },
  por_hacer: { bg: "#fdf0e6", border: "#f2bd8e", text: "#b8520f" },
  // El mostaza puro no contrasta sobre blanco, por eso el texto va oscurecido.
  en_curso: { bg: "#fefbe0", border: "#ecd94a", text: "#8a7500" },
  resuelto: { bg: "#eaf8ee", border: "#96ddaa", text: "#1a8c35" },
  subido: { bg: "#f1edf6", border: "#b9a5cf", text: "#5e4276" },
};

export const textoSobreFase = (fase) => (fase === "en_curso" ? "#5f5550" : "#fff");

export const chatCerrado = (fase) => fase === "rechazado" || fase === "subido" || fase === "no_enviado";

export const TEXTO_CHAT_CERRADO =
  "Este reporte ya quedó atendido y su chat se cerró. Si necesitas algo más, levanta un reporte nuevo.";

export const TEXTO_CHAT_CERRADO_AGENTE =
  "Este reporte quedó cerrado — el chat se cerró para el cliente y para soporte.";

export const TEXTO_CHAT_NO_ENVIADO =
  "Tu empresa revisó esta petición y la atenderá internamente. Si necesitas algo más, levanta un reporte nuevo.";

export const TEXTO_CHAT_SUBIDO =
  "Este reporte ya se aplicó en el sistema y su chat se cerró. Si necesitas algo más, levanta un reporte nuevo.";

export const TEXTO_CHAT_SUBIDO_AGENTE =
  "Este reporte ya está aplicado — el chat quedó cerrado para el cliente y para soporte.";

// Aviso que reemplaza al composer, según por qué se cerró el chat.
export const textoChatCerrado = (fase) =>
  fase === "subido" ? TEXTO_CHAT_SUBIDO : fase === "no_enviado" ? TEXTO_CHAT_NO_ENVIADO : TEXTO_CHAT_CERRADO;

export const textoChatCerradoAgente = (fase) =>
  fase === "subido" ? TEXTO_CHAT_SUBIDO_AGENTE : TEXTO_CHAT_CERRADO_AGENTE;

export const HORARIO_ATENCION =
  "Horario de atención: lunes a viernes de 9:00 a 14:00 y de 16:00 a 19:00 hrs.";

export const HORARIO_ATENCION_CORTO = "Lun a vie · 9:00-14:00 y 16:00-19:00";

export const ETIQUETAS_RESPUESTA = {
  si: { label: "Se cumplió", color: "green" },
  no: { label: "Requiere ajuste", color: "gold" },
};

export const SOPORTE_TEMA = {
  primario: "#fa8c16",
  primarioFuerte: "#d9720d",
  bg: "#fafafa",
  surface: "#ffffff",
  border: "#f0f0f0",
  textPrimary: "#262626",
  textSecondary: "#8c8c8c",
  bubbleIn: "#f0f0f0",
  bubbleOut: "rgba(250, 140, 22, 0.18)",
};

export const TIPOS_INCIDENCIA = {
  asistencia_servicio: "Asistencia con el Servicio",
  revision_funcionamiento: "Revisión de Funcionamiento",
  nueva_funcion: "Solicitud de Nueva Función",
};

export const OPCIONES_TIPO_INCIDENCIA = Object.entries(TIPOS_INCIDENCIA).map(([value, label]) => ({ value, label }));

export const MIN_DESCRIPCION = 50;
export const MIN_JUSTIFICACION = 50;
export const MIN_MOTIVO_NO_ENVIO = 50;

export const textoSuficiente = (texto, minimo) => (texto || "").trim().length >= minimo;
